import React, { useState } from 'react'
import styles from './EventCard.module.css'
import ActionPanel from './ActionPanel'

const EventCard = ({ event }) => {
    const [isExpanded, setIsExpanded] = useState(false)

    return (
        <div className={`${styles.card} ${isExpanded ? styles.expanded : ''}`}>
            {/* Header — always visible */}
            <div className={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
                <div className={styles.headerLeft}>
                    <div className={styles.iconContainer}>📅</div>
                    <div className={styles.headerText}>
                        <h3 className={styles.title}>{event.title}</h3>
                        <div className={styles.meta}>
                            {event.date && <span className={styles.metaItem}>📆 {event.date}</span>}
                            {event.time && <span className={styles.metaItem}>⏰ {event.time}</span>}
                            {event.location && <span className={styles.metaItem}>📍 {event.location}</span>}
                        </div>
                    </div>
                </div>
                <div className={styles.headerRight}>
                    {event.match > 0 && (
                        <div className={styles.matchBadge}>
                            <span className={styles.matchPercent}>{event.match}%</span>
                            <span className={styles.matchLabel}>match</span>
                        </div>
                    )}
                    <button className={styles.expandButton}>
                        {isExpanded ? '▲' : '▼'}
                    </button>
                </div>
            </div>

            {/* Expanded content */}
            {isExpanded && (
                <div className={styles.expandedContent}>
                    {event.description && (
                        <p className={styles.description}>{event.description}</p>
                    )}

                    {event.whyMatch && event.whyMatch.length > 0 && (
                        <div className={styles.whyMatch}>
                            <h4 className={styles.sectionHeading}>WHY IS IT A STRONG MATCH?</h4>
                            <ul className={styles.matchList}>
                                {event.whyMatch.map((reason, index) => (
                                    <li key={index} className={styles.matchItem}>
                                        <span className={styles.checkIcon}>✓</span>
                                        {reason}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {event.actions && event.actions.length > 0 && (
                        <ActionPanel actions={event.actions} />
                    )}

                    {event.url && (
                        <a
                            href={event.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.registerLink}
                            onClick={e => e.stopPropagation()}
                        >
                            Register for Event →
                        </a>
                    )}
                </div>
            )}
        </div>
    )
}

export default EventCard
